import styleInject from '../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js';

var css_248z = "/*\n *\n * Copyright (c) Vaisala Oyj. All rights reserved.\n *\n */\n/*\n *\n * Copyright (c) Vaisala Oyj. All rights reserved.\n * \n */\n.vai-tab-gap {\n  flex: none;\n  width: 16px;\n  padding: 0;\n  min-height: 40px;\n}";
styleInject(css_248z);

export { css_248z as default };
